import { Incrementer } from '@components/Incrementer';
import { CouchIcon } from '@src/assets';
import React from 'react';
import { IncrementerGroup } from './styled/IncrementerGroup.styled';
import * as styled from './styled/RoomsGroup.styled';
import { TitleGroup } from './TitleGroup';

export const RoomsGroup: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    return (
        <styled.RoomsGroup>
            <TitleGroup title="Rooms" Icon={CouchIcon} />
            <IncrementerGroup>
                <Incrementer
                    disabled={disabled}
                    name={'bedrooms'}
                    label={'Bedrooms'}
                    readOnly={false}
                />
                <Incrementer
                    disabled={disabled}
                    name={'bathrooms'}
                    label={'Bathrooms'}
                    incrementStep={0.5}
                    roundToDecimal={true}
                    readOnly={false}
                />
            </IncrementerGroup>
        </styled.RoomsGroup>
    );
};
